import { render, staticRenderFns } from "./ExperienceScreen.vue?vue&type=template&id=010c47fc&scoped=true"
import script from "./ExperienceScreen.vue?vue&type=script&lang=js"
export * from "./ExperienceScreen.vue?vue&type=script&lang=js"
import style0 from "./ExperienceScreen.vue?vue&type=style&index=0&id=010c47fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010c47fc",
  null
  
)

export default component.exports